import { makeStyles } from "@material-ui/core";

export const useClassnames = makeStyles((theme) => ({
  paper: {
    borderLeftStyle: "solid",
    borderLeftColor: theme.palette.primary.main,
    borderLeftWidth: "10px",
  },
}));
